import React from 'react';
import { BsJournalText, BsDatabaseCheck, BsDatabaseAdd, BsJournalArrowUp } from 'react-icons/bs';
import useStore from '../../store/useStore';
import AgentCard from './AgentCard';

// Mapeo de íconos para los agentes
const agentIcons = {
  learning: <BsJournalText size={28} />,
  Lineamientos: <BsDatabaseCheck size={28} />,
  LRequerimientos: <BsJournalArrowUp size={28} />,
  Inventory: <BsDatabaseAdd size={28} />,
};

/**
 * Componente para la selección de agentes inteligentes
 */
const AgentSelection = () => {
  const { agents, setSelectedAgent } = useStore();

  // Obtener el ícono para un agente específico
  const getAgentIcon = (agentKey) => {
    return agentIcons[agentKey];
  };

  return (
    <div className="flex flex-col items-center justify-start pt-20 min-h-[80vh] w-full max-w-4xl mx-auto p-6">
      <div className="text-center mb-10">
        <div className="inline-flex justify-center items-center p-4 rounded-full mb-6">
          <img src="v-SISE-Logo-Mayo.png" alt="v-SISE Logo" className="h-14" />
        </div>
        <p className="text-gray-600 dark:text-gray-400 text-lg max-w-xl mx-auto">
          Para comenzar, selecciona un Agente de IA especializado
        </p>
      </div>
      
      <div className="w-full flex flex-wrap justify-center items-start gap-6">
        {agents.map(agent => (
          <div key={agent.key} className="w-80"> {/* Container for fixed width and key */}
            <AgentCard
              icon={getAgentIcon(agent.key)}
              name={agent.name}
              description={agent.description}
              onClick={() => setSelectedAgent(agent.key)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgentSelection;
